module.exports = __webpack_public_path__ + "static/cisco-7c8e3d91c6708fce205ff14d693f3f73.png";